<template>
  <h1 class="text-center">Badges</h1>
</template>

<script>
export default {
  name: "Badges"
}
</script>

<style scoped>

</style>